import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3fza0fmxih: FaireBrandEntity = {
  token: "b_3fza0fmxih",
  type: "brand",
  name: "Bel Kai",
  avatarUrl:
    "https://cdn.faire.com/fastly/960a9bfa315156ac4ab50c2010fc08fb35287595560ce2828e6784765cf58550.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/7820e238d49e948f5653c6b4837d48587c1883f66daff0f989c83ffbbfcb2b93.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/960a9bfa315156ac4ab50c2010fc08fb35287595560ce2828e6784765cf58550.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7820e238d49e948f5653c6b4837d48587c1883f66daff0f989c83ffbbfcb2b93.jpeg",
  location: "Winona Lake, IN, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 24,
  isTopShop: true,
  isInsider: true,
  description:
    "Bel Kai was established in 2006 in Long Beach, CA by Whitney Wright. It began as a jewelry studio in the dining room of her California bungalow. With previous experience in jewelry making as a hobby and after receiving a gift of a pendant made from paper, she was inspired to create a collection of necklaces. Simple in concept, often just a chain & a pendant. Made beautifully unique by sealing original artwork & custom images sealed in sterling silver settings. The first years were quite the hustle and marked by art shows, craft fairs, open houses & small wholesale orders for local boutiques. Because the designs were original, the possibilities for personalized work were limitless and requests for custom pendants soon followed. A retail website followed, and we maintained a strong community over the years. In 2021, the decision was made to solely sell the Bel Kai collection through wholesale channels.\n\nIn February 2021, a partnership with Vida Plena was established. Vida Plena, an artisan studio in the Dominican Republic, exists to empower women to break the cycle of poverty in their communities. They offer a holistic approach to training, offering each woman counseling, language tutoring, eventually supporting women as they become entrepreneurs. \n\nAs of March 2026, Bel Kai Jewelry is no longer produced in the Dominican Republic, a shift made to better align with production capacity. ",
  meta: {
    source: "api",
    importedAt: "2026-05-06T20:38:31.192Z",
    importedBy: "entity-db-cli",
  },
};
